/*
 * product-fit.js
 * Bouton « Choisir le L » du conseil de taille (snippets/product-variant-picker).
 * Il coche la case de taille correspondante : le clic sur un radio declenche
 * l'evenement change que <variant-selects> ecoute deja, donc le prix, l'image
 * et le panier suivent comme si le visiteur avait clique la case lui-meme.
 * Delegation sur le document : le bloc est re-rendu a chaque changement de
 * variante, un ecouteur pose dessus serait perdu.
 */
(() => {
  if (window.__rpProductFit) return;
  window.__rpProductFit = true;

  document.addEventListener('click', (evt) => {
    const bouton = evt.target instanceof Element ? evt.target.closest('[data-choisir-taille]') : null;
    if (!bouton) return;

    const valeur = bouton.dataset.choisirTaille;
    const zone = bouton.closest('variant-selects') || document;
    const radio = Array.from(zone.querySelectorAll('input[type="radio"]')).find((r) => r.value === valeur);
    if (radio && !radio.checked) radio.click();
  });
})();
